/**
 * Implementation to Setting Card component
 *
 * @author - Harsh Tomar
 */

// Dependencies
import React, { ReactChild, useState } from "react";
import { FiEdit2 } from "react-icons/fi";

type Props = {
  heading: string;
  children: ReactChild | ReactChild[]
  editing: boolean,
  onEditClick?: () => void;
  onEditSave?: () => void;
  onEditCancel?: () => void;
};

export type Field = {
  label: string;
  value: string;
  type: "TEXT" | "URL" | "COLOR" | "EMAIL";
};

export default function SettingCard(props: Props) {

  function _renderField(field: Field) {
    switch (field.type) {
      case "COLOR":
        return (
          <div className="flex justify-between p-2">
            <div>
              <p className="text-gray-400 font-semibold">{field.label}</p>
              <p className="text-lg">
                <span
                  className="w-6 h-6 rounded-lg inline-flex align-middle"
                  style={{ backgroundColor: field.value }}
                ></span>
                &nbsp;&nbsp;{field.value}
              </p>
            </div>
          </div>
        );
      default:
        return (
          <div className="flex justify-between p-2">
            <div>
              <p className="text-gray-400 font-semibold">{field.label}</p>
              {props.editing ?
                <input type="text" value={field.value} className="input-field-primary" /> 
              :<p className="text-lg">{field.value}</p>
            }
            </div>
          </div>
        );
    }
  }

  function _handleEditClick() {
    props.onEditClick && props.onEditClick()
  }

  function _handleEditCancel() {
    props.onEditCancel && props.onEditCancel();
  }

  function _handleEditSave() {
    props.onEditSave && props.onEditSave();
  }

  return (
    <div className="bg-white rounded-lg shadow py-4 px-6 mb-4">
      <div className="flex justify-between">
        <h1 className="text-lg font-semibold">{props.heading}</h1>

        {!props.editing && (
          <button
            className="btn-primary-outline py-1.5"
            onClick={_handleEditClick}
          >
            <FiEdit2 className="icon" /> Edit
          </button>
        )}
      </div>
      <div className="divide-y">
        {props.children}
      </div>

      {props.editing && (
        <div className="flex justify-end">
          <button className="mr-5" onClick={_handleEditCancel}>
            Cancel
          </button>
          <button className="btn-primary" onClick={_handleEditSave}>Save</button>
        </div>
      )}
    </div>
  );
}
